import React from 'react';
import { Box, Card, CardContent, Typography, Stack, Avatar, Divider, Tooltip } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FlowRow } from './FlowRow';

type ScWalletCardProps = {
    selectedTab: string;
    currency: string;
    getVal: (mapName: string, op: string) => number;
    getDetails: (mapName: string, op: string) => any;
};

export const ScWalletCard = ({ selectedTab, currency, getVal, getDetails }: ScWalletCardProps) => {
    return (
        <Card elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 4, height: '100%' }}>
            <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={3}>
                    <Box>
                        <Stack direction="row" alignItems="center" spacing={0.5} mb={0.5}>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>
                                SC Wallet Details
                            </Typography>
                            <Tooltip title="The SC is the operators' wallet. For EUR, all funds from all operators end up in this wallet. PSP fees are also deducted from this wallet." arrow placement="top">
                                <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled', cursor: 'pointer' }} />
                            </Tooltip>
                        </Stack>
                    </Box>
                    <Avatar sx={{ bgcolor: '#eff6ff', color: '#2563eb', width: 32, height: 32 }}>
                        <AccountBalanceWalletIcon fontSize="small" />
                    </Avatar>
                </Stack>

                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.disabled', letterSpacing: '0.5px', mb: 1, display: 'block' }}>FUTURE SC CREDITS</Typography>
                    <FlowRow
                        label="From Escrow to SC"
                        amount={getVal('amount_awaited_transfer_from_escrow_to_operator', selectedTab)}
                        details={getDetails('amount_awaited_transfer_from_escrow_to_operator', selectedTab)}
                        type="in" currency={currency}
                        tooltip="Represents the Operator's share of PAYMENTs pending transfer."
                    />
                    <FlowRow
                        label="From Producers to SC"
                        amount={getVal('amount_awaited_transfer_from_producer_to_operator', selectedTab)}
                        details={getDetails('amount_awaited_transfer_from_producer_to_operator', selectedTab)}
                        type="in" currency={currency}
                        tooltip="Represents all funds pending transfer from seller wallets to the SC (REFUND, FEE, PAYMENT COD)."
                    />

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.disabled', letterSpacing: '0.5px', mb: 1, display: 'block' }}>FUTURE SC DEBITS</Typography>
                    <FlowRow
                        label="Awaited Payout"
                        amount={getVal('amount_awaited_payout_to_operator', selectedTab)}
                        details={getDetails('amount_awaited_payout_to_operator', selectedTab)}
                        type="out" currency={currency}
                        tooltip="Operator payouts to be transferred to the BE bank account."
                    />
                </Box>
            </CardContent>
        </Card>
    );
};